// extracted by mini-css-extract-plugin
export default {"match__text":"MatchContentFromPartner_match__text__HWDLi"};